module.exports = __webpack_public_path__ + "assets/img/5.8f992364.jpg";